import { render, staticRenderFns } from "./siSalesOrders.vue?vue&type=template&id=1e0dd62e&"
import script from "./siSalesOrders.vue?vue&type=script&lang=js&"
export * from "./siSalesOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "siSalesOrders.vue"
export default component.exports